import React, { useEffect } from 'react';
import { LoginModal } from 'features/user/userModals/LoginModal';
import { SignupModal } from 'features/user/userModals/SignupModal';
import useModal from 'helpers/useModal';
import { useAuth } from '../helpers/authContext';
import { Link } from 'react-router-dom';
import ContentCreatePostModal from 'features/content/contentModals/ContentCreatePostModal';
import ProfileDropdown from './ProfileDropdown';
import NotificationsDropdown from './NotificationsDropdown';
import SearchBar from './SearchBar';
import ShellIcon from './ShellIcon';

export const AppNavbar = () => {
  const { user, app_settings, updateAppSettings, signedIn } = useAuth();
  const { isOpenLoginModal, toggleLoginModal, isOpenSignupModal, toggleSignupModal } = useModal();
  const { isOpenContentCreatePostModal, toggleContentCreatePostModal } = useModal();
  const light = app_settings?.app_mode === 'default';
  useEffect(() => {
    document.documentElement.classList.remove('dark', 'default');
    document.documentElement.classList.add(light ? 'default' : 'dark');
    if (!app_settings?.app_mode) updateAppSettings({ ...app_settings, app_mode: 'dark' });
  }, [app_settings?.app_mode]);
  return <>
    <header className="speem-topbar">
      <Link to="/" className="speem-brand" aria-label="Speem home"><img src={light ? '/assets/img/logo.webp' : '/assets/img/logo-green.png'} alt="Speem" /></Link>
      <SearchBar />
      <div className="speem-topbar-actions">
        <button type="button" className="speem-icon-button speem-theme-button" aria-label={light ? 'Switch to dark theme' : 'Switch to light theme'} title={light ? 'Dark theme' : 'Light theme'} onClick={() => updateAppSettings({ ...app_settings, app_mode: light ? 'dark' : 'default' })}><ShellIcon name={light ? 'moon' : 'sun'} size={17} /></button>
        <Link to="/settings" className="speem-icon-button speem-settings-button" aria-label="Settings" title="Settings"><ShellIcon name="settings" size={17} /></Link>
        <button type="button" className="speem-upload-button" aria-label="Upload" title="Upload" onClick={signedIn ? toggleContentCreatePostModal : toggleLoginModal}><ShellIcon name="upload" size={16} /><span>Upload</span></button>
        {signedIn ? <>
          <div className="speem-notifications"><NotificationsDropdown /></div>
          <ProfileDropdown user={user} imageLink={`https://steemitimages.com/u/${user}/avatar`} onOpenLogin={toggleLoginModal} />
        </> : <>
          <button type="button" className="speem-signup-button" onClick={toggleSignupModal}>Sign up</button>
          <button type="button" className="speem-login-button" onClick={toggleLoginModal}>Log in</button>
        </>}
      </div>
    </header>
    <LoginModal isShowing={isOpenLoginModal} hide={toggleLoginModal} onSignup={toggleSignupModal} />
    <SignupModal isShowing={isOpenSignupModal} hide={toggleSignupModal} />
    <ContentCreatePostModal isShowing={isOpenContentCreatePostModal} hide={toggleContentCreatePostModal} community={undefined} />
  </>;
};
export default AppNavbar;
